<app-navigation-layout [hideHeader]='true' [hideNavigation]="hideNavigation">
  <span main-container>
    <app-partner-code-login #partnerCodeLogin (back)="onBack()" (next)="loggedIn()"
      (registerAsGuest)="registerAsGuest()" (authorizationAsGuest)="authorizationAsGuest()"
      [allowGuestAuthorization]='allowGuestSale'
      (navigationVisibilityChange)="onNavigationVisibilityChange(partnerCodeLogin.showNavigationBack)">
    </app-partner-code-login>
  </span>
  <span menu-container>
    <app-booking-basket-simple-view></app-booking-basket-simple-view>
  </span>
  <span navigation-container>
    <app-backward-forward (backwardClick)="onBack()" [hideNext]="true">
    </app-backward-forward>
  </span>
</app-navigation-layout>
